import axios from "axios";

const criptografarService = async function (bodyreq) {
  var retorno = {}

  try {
      await axios({
        method: 'post',
        url: `${process.env.VUE_APP_ALIANCA_CRIPTOGRAFIA}/criptografar?api-key=${process.env.VUE_APP_ALIANCA_CRIPTOGRAFIA_KEY}`,
        headers: { "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers": "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With"
              },
        data: bodyreq
      }).then(response => {
        retorno = response.data.chave
      })
      .catch(error => {
        retorno = undefined
        console.log(error)
      })
  } catch (e) {
    console.log(e)
  }

  return retorno
};

export default criptografarService;
